module.exports = "/assets/data/f2ac410bd017abd4b7fafbdfff68f899-NR31.data.json";